import React from "react";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import BannerSectionStyle4 from "../Section/BannerSection/BannerSectionStyle4";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import Spacing from "../Spacing";
import { useNavigate } from "react-router-dom";
const teamData = [
  {
    imgUrl: "/images/doctors/doctor_1.png",
    department: "Emergency Department",
    name: "Expert Name",
    designation: "Health and Wellness Specialist",
    description: "Expert Description",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "cardiology",
    href: "/doctors/",
  },
  {
    imgUrl: "/images/doctors/doctor_2.png",
    department: "Emergency Department",
    name: "Expert Name",
    designation: "Health and Wellness Specialist",
    description: "Expert Description",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "emergency",
    href: "/doctors/",
  },
  {
    imgUrl: "/images/doctors/doctor_3.png",
    department: "Emergency Department",
    name: "Expert Name",
    designation: "Health and Wellness Specialist",
    description: "Expert Description",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "pediatric",
    href: "/doctors/",
  },
];

export default function Doctors() {
  pageTitle("Doctors");

  const navigate = useNavigate();

  const userLogin = () => {
    navigate("/doctors/auth");
  }

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/doctors/banner_bg.svg"
        imgUrl="/images/nhwm/consultant.jpg"
        title="Introduce You to <br />Our Doctors"
        subTitle="The list of certified Healthcare Experts with years of <br/> professional experiences"
      />
      <Section topMd={50} bottomMd={50} bottomLg={100} bottomXl={110}>
        <Spacing md={50} />
        <div className="flex justify-center mt-[100px] md:mt-[210px] lg:mt-[0]">
          <div className="wave-container w-fit">
            <h1 className="wave-text text-[3rem] md:text-[5rem] font-mono tracking-wide mb-0">
              <span>C</span>
              <span>O</span>
              <span>M</span>
              <span>I</span>
              <span>N</span>
              <span>G</span>
              <span className="ml-5">S</span>
              <span>O</span>
              <span>O</span>
              <span>N</span>
            </h1>
          </div>
        </div>
      </Section>
      {/* <Section topMd={50} bottomMd={50} bottomLg={100} bottomXl={110}>
        <div className="flex gap-12 w-full justify-evenly items-center py-5">
          <Card>
            <div className="flex justify-center items-center flex-col">
              <h3>Continue As Doctor</h3>
              <p>For Doctors</p>
              <button className="bg-[#307bc4] text-white px-4 py-2 rounded-md" onClick={userLogin}>
                Continue
              </button>
            </div>
          </Card>
        </div>
      </Section> */}
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/nhwm/about_bg.jpg"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
        />
      </Section>
    </>
  );
}

// using in doctors page